import { useOpenable, useOrganization } from 'hooks';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useFeatureFlags } from 'utils/features';
import LocalStore from 'utils/localStorageUtils';
import { isProAccount } from 'utils/organizationSubscriptionStatusUtils';
import useIsEssentialPlan from '../hooks/useIsEssentialPlan';
import ImportantAccountChangesView from '../ImportantAccountChangesView/ImportantAccountChangesView';

export const FREEMIUM_ACCOUNT_CHANGES_SEEN_KEY = 'freemium-account-changes-seen';

const FreemiumAccountChangesNotice = () => {
  const isFreemiumLimited = useFeatureFlags('FREEMIUM_LIMITED');
  const { subscriptionStatus } = useOrganization();
  const isPro = subscriptionStatus && isProAccount(subscriptionStatus) ? true : false;
  const isEssential = useIsEssentialPlan();
  const organization = useOrganization();
  const orgId = organization?.id;
  const noticeOpenable = useOpenable();
  const location = useLocation();
  const isSubscriptionsRoute = location.pathname.startsWith('/settings/subscription');

  useEffect(() => {
    if (isSubscriptionsRoute) {
      return;
    }
    const acknowledged: Record<string, boolean> = LocalStore.get(FREEMIUM_ACCOUNT_CHANGES_SEEN_KEY) ?? {};
    if (!isPro && !isEssential && isFreemiumLimited && orgId && !acknowledged[orgId]) {
      noticeOpenable.open();
      LocalStore.set(FREEMIUM_ACCOUNT_CHANGES_SEEN_KEY, { ...acknowledged, [orgId]: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFreemiumLimited, isPro, isEssential, orgId, isSubscriptionsRoute]);

  return <ImportantAccountChangesView isOpen={noticeOpenable.isOpen} onClose={noticeOpenable.close} />;
};

export default FreemiumAccountChangesNotice;
